import { render, staticRenderFns } from "./SpeciesChooser.vue?vue&type=template&id=b8d5026a&scoped=true&"
import script from "./SpeciesChooser.vue?vue&type=script&lang=ts&"
export * from "./SpeciesChooser.vue?vue&type=script&lang=ts&"
import style0 from "./SpeciesChooser.vue?vue&type=style&index=0&id=b8d5026a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d5026a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VAutocomplete,VChip})
